import Tab from 'portaltransparencia-common/components/Tab.react.js';
import Tabs from 'portaltransparencia-common/components/Tabs.react.js';
import PropTypes from 'prop-types';
import React from 'react';
import FormDetailInformacoesAdicionais from './FormDetailInformacoesAdicionais.react';
import FormDetailDotacoes from './FormDetailDotacoes.react';
import FormDetailPlanosTrabalhos from './FormDetailPlanosTrabalhos.react';
import FormDetailAnexos from './FormDetailAnexos.react';
import FormDetailMovimentacoes from './FormDetailMovimentacoes.react';
import FormDetailEntidadesBeneficiadas from './FormDetailEntidadesBeneficiadas.react';
import FormDetailLocalidadesBeneficiadas from './FormDetailLocalidadesBeneficiadas.react';
import { TipoEmendaParlamentar } from '../TipoEmendaParlamentar';

export function FormDetailTabs({ emenda, tipo, isIntegradoOxy }) {
  const isEmendaMunicipal = tipo === TipoEmendaParlamentar.MUNICIPAL;

  return (
    <Tabs id="tabs">
      <Tab
        onlyTable
        tableResponsive
        title="Informações Adicionais"
        active={true}
      >
        <FormDetailInformacoesAdicionais
          informacaoAdicional={emenda.get('informacaoAdicional')}
          tipo={tipo}
          isIntegradoOxy={isIntegradoOxy}
        />
      </Tab>

      <Tab onlyTable tableResponsive title="Classificação Orçamentária">
        <FormDetailDotacoes dotacoes={emenda.get('dotacoes')} />
      </Tab>

      <Tab onlyTable tableResponsive title="Plano de Trabalho">
        <FormDetailPlanosTrabalhos
          planosTrabalhos={emenda.get('planosTrabalhos')}
          tipo={tipo}
          isIntegradoOxy={isIntegradoOxy}
        />
      </Tab>

      <Tab onlyTable tableResponsive title="Movimentação" renderOnlyWhenActive>
        <FormDetailMovimentacoes idEmenda={emenda.get('id')} />
      </Tab>

      {(isIntegradoOxy || isEmendaMunicipal) && (
        <Tab
          onlyTable
          tableResponsive
          title="Entidades Beneficiadas"
          renderOnlyWhenActive
        >
          <FormDetailEntidadesBeneficiadas idEmenda={emenda.get('id')} />
        </Tab>
      )}

      {(isIntegradoOxy || isEmendaMunicipal) && (
        <Tab
          onlyTable
          tableResponsive
          title="Localidades Beneficiadas"
          renderOnlyWhenActive
        >
          <FormDetailLocalidadesBeneficiadas idEmenda={emenda.get('id')} />
        </Tab>
      )}

      <Tab onlyTable tableResponsive title="Documentos">
        <FormDetailAnexos anexos={emenda.get('documentos')} />
      </Tab>
    </Tabs>
  );
}

FormDetailTabs.propTypes = {
  emenda: PropTypes.object.isRequired
};
